import { useQuery } from "react-query";
import AlarmSetpointsDataService from "../../services/alarm-setpoints-data-service/AlarmSetpointsDataService";
import { IDisabledScheduleDTO } from "../../services/alarm-setpoints-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseTagSetpointDisabledScheduleParameters = {
    groupID: number,
    tagID: number,
    setpointID: number;
} & BaseUseQueryParameters<IDisabledScheduleDTO>;

export function useTagSetpointDisabledSchedule({
    groupID,
    tagID,
    setpointID,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseTagSetpointDisabledScheduleParameters) {
    return useQuery<IDisabledScheduleDTO | undefined, RestError>(
        keys.disableSchedule(groupID, tagID, setpointID),
        ({ signal }) => {

            return Number.isFinite(groupID) && Number.isFinite(tagID) && Number.isFinite(setpointID)
                ? AlarmSetpointsDataService.getDisabledScheduleForTagSetPoint(
                    groupID,
                    tagID,
                    setpointID,
                    signal)
                : Promise.resolve(undefined);
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false
        }
    );
}
